import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchScientificArticles() {
  const q = query(collection(db, 'scientific_articles'), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
